import Slider from "~/components/ui/Slider";
import Icon from "~/components/ui/Icon";
import type { Product } from "@decocms/apps-commerce/types";
import type { ManualSimplifiedProduct } from "./shelfTypes";

interface ShelfDotsProps {
  products: Product[] | ManualSimplifiedProduct[];
}

function ShelfDots({ products }: ShelfDotsProps) {
  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @property --dot-progress {
            syntax: '<percentage>';
            inherits: false;
            initial-value: 0%;
          }
          `,
        }}
      />
      <ul className="carousel col-span-full z-10 row-start-4 w-auto h-6 justify-self-center justify-center mt-4 xl:mt-0 xl:justify-start bg-none">
        {products?.map((_, index) => (
          <li
            key={index}
            className="carousel-item pl-1 lg:pl-2 focus:bg-black lg:[&:not(:nth-child(5n-4))]:hidden"
          >
            <Slider.Dot index={index}>
              <div className="hidden group-disabled:flex">
                <Icon id={"ActiveDot"} size={12} />
              </div>
              <div className="flex group-disabled:hidden">
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="11"
                    height="11"
                    rx="5.5"
                    stroke="#CCCCCC"
                  />
                  <rect
                    opacity="0.16"
                    x="2"
                    y="2"
                    width="8"
                    height="8"
                    rx="4"
                    fill="#434343"
                  />
                </svg>
              </div>
            </Slider.Dot>
          </li>
        ))}
      </ul>
    </>
  );
}

export default ShelfDots;

